import Lenis from './helpers/Lenis.js';

import CoreAnimatedGif from './components/core/CoreAnimatedGif'
import CoreVideo from './components/core/CoreVideo'
import CoreHoverVideo from './components/core/CoreHoverVideo'
import CoreModal from './components/core/CoreModal'
import CoreSlideshow from './components/core/CoreSlideshow'
import ScrollObject from './components/core/ScrollObject'
import SplitText from './components/core/SplitText'
import CoreExpandable from './components/core/CoreExpandable'
import CoreDrag from './components/core/CoreDrag.js'
import CoreTabs from './components/core/CoreTabs.js'
import CoreAudio from './components/core/CoreAudio.js'

import BlockNetwork from './components/blocks/BlockNetwork'
import BlockLanguages from './components/blocks/BlockLanguages'
import BlockHome from './components/blocks/BlockHome.js'
import BlockHero from './components/blocks/BlockHero.js'
import BlockValues from './components/blocks/BlockValues.js'
import BlockPortal from './components/blocks/BlockPortal.js'
import BlockLocations from './components/blocks/BlockLocations.js'
import BlockCareers from './components/blocks/BlockCareers.js'
import BlockNews from './components/blocks/BlockNews.js'
import BlockWave from './components/blocks/BlockWave.js'
import BlockEnterprise from './components/blocks/BlockEnterprise.js'
import BlockParallaxFloat from './components/blocks/BlockParallaxFloat.js'
import BlockPrompt from './components/blocks/BlockPrompt.js'
import BlockLongForm from './components/blocks/BlockLongForm.js'
import BlockTranscribe from './components/blocks/BlockTranscribe.js'
import BlockTranscribeChat from './components/blocks/BlockTranscribeChat.js'
import BlockChart from './components/blocks/BlockChart.js'
import BlockIframe from './components/blocks/BlockIframe.js'
import BlockWidget from './components/blocks/BlockWidget.js'
import BlockAboutHero from './components/blocks/BlockAboutHero.js'
import BlockNav from './components/blocks/BlockNav.js'
import BlockVoiceEmotion from './components/blocks/BlockVoiceEmotion.js'
import BlockArticleSchema from './components/blocks/BlockArticleSchema.js'
import BlockNumbers from './components/blocks/BlockNumbers.js'
import BlockHeroGrid from './components/blocks/BlockHeroGrid.js'
import BlockSoundWave from './components/blocks/BlockSoundWave.js'
import BlockHeroCircles from './components/blocks/BlockHeroCircles.js'
import BlockReveal from './components/blocks/BlockReveal.js'
import BlockEdits from './components/blocks/BlockEdits.js'
import ManualChapterNav from './components/blocks/ManualChapterNav.js'
import ManualDef from './components/blocks/ManualDef.js'
import ManualRail from './components/blocks/ManualRail.js'

import AppHeader from './components/AppHeader.js'
import WebApplication from './components/WebApplication'

import BackgroundFade from './components/BackgroundFade.js'
import LazyLoading from './components/LazyLoading.js'
import AppDropdown from './components/AppDropdown'
import AppSearch from './components/AppSearch';
import ScrollExpand from './components/ScrollExpand';
import ScrollScale from './components/ScrollScale';

import WaitlistModale from './components/WaitlistModale';
import GLBlurNumber from './components/gl/GLBlurNumber.js'

// This needs to be a global function attached to the window.
window.onYouTubeIframeAPIReady = () => {
  const event = new Event('youtubeAPIRready')
  document.dispatchEvent(event)
}

console.log('Microsoft.ai – v3.7.4')

/* Async load the BlogGL and its libraries */
const loadBlockGL = () => import('./components/blocks/BlockGL.js');
const blockGl = document.querySelector('block-gl');
if (blockGl) {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          observer.disconnect();
          loadBlockGL();
          break;
        }
      }
    }, {
      rootMargin: '300px',
    });
    observer.observe(blockGl);
  } 
  else {
    loadBlockGL();
  }
}



// Fix UHF WCAG issue
if (document.readyState === 'complete') {
  onReady()
}
else {
  window.addEventListener("DOMContentLoaded", onReady );
}
function onReady() {
  document.querySelectorAll('.uhf-skip-link')?.forEach(el => {
    el.parentNode.removeChild(el);
  });
}